var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.69,
    height: 71.412,
    viewBox: "0 0 59.69 91.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "xoilkvza2a",
    x: 0,
    y: 29.894,
    width: 59.69,
    height: 61.518,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59551"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#xoilkvza2a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7589",
    d: "M-371.155 251.4a20.723 20.723 0 0 0-2.109 9.092c0 11.512 20.844 34.426 20.844 34.426s20.845-22.914 20.845-34.426a20.721 20.721 0 0 0-2.11-9.092c-4.832 1.78-11.486 2.808-18.736 2.808s-13.902-1.031-18.734-2.808zm25.088 11.645a6.353 6.353 0 0 1-6.352 6.352 6.353 6.353 0 0 1-6.353-6.352 6.353 6.353 0 0 1 6.353-6.352 6.353 6.353 0 0 1 6.352 6.349z",
    transform: "translate(382.262 -215.5)",
    style: {
      fill: "#612166"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7590",
    d: "m-373 232.606 1.253-.462c4.918-1.814 11.593-2.812 18.794-2.812s13.877 1 18.8 2.812l1.253.462.437 1.262.493 1.426c3.063-2.11 5.507-4.493 5.724-7.844-.294-4.533-4.656-7.3-9.122-10.006-4.756-2.543-9.617-5.025-17.581-5.192-7.965.167-12.825 2.649-17.581 5.192-4.466 2.707-8.828 5.473-9.122 10.006.217 3.351 2.662 5.734 5.723 7.844l.494-1.425z",
    transform: "translate(382.795 -212.251)",
    style: {
      fill: "#612166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7591",
    d: "M-373.443 245.806c4.089 2.46 11.963 4.127 21.008 4.127s16.92-1.667 21.01-4.127l-3.192-9.21c-4.391-1.62-10.746-2.638-17.818-2.638s-13.426 1.018-17.818 2.638z",
    transform: "translate(382.279 -214.054)",
    style: {
      fill: "#612166"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logoSm.9feb1dc243ab307d84d588b2c73a908a.svg";
export { ForwardRef as ReactComponent };